import { useEnabledFeatures } from '@calendly/feature-check-react'

import { NOTETAKER_EXCLUDE_MSA_GATE } from 'shared/constants/notetaker_visibility'

/** `'off'` means MSA org. `undefined` (gate absent) fails open to non-MSA. */
export const useNotetakerMsaOrg = () => useEnabledFeatures()?.[NOTETAKER_EXCLUDE_MSA_GATE] === 'off'
